import React from 'react';
import YearButton from './YearButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronRight,
  faChevronLeft,
} from '@fortawesome/pro-light-svg-icons';
import styled from 'styled-components';
import { COLORS } from 'shared/design-system/settings/variables/Colors';
import { YearKeyValuePair, YearSelectionArray } from './utils';

interface PeriodSelectorProps {
  isThirdParty: boolean;
  selectedYear: YearKeyValuePair | undefined;
  years: YearSelectionArray;
  handlePrevious: () => unknown;
  handleNext: () => unknown;
  handleChange: (value: YearKeyValuePair) => unknown;
}

const StyledDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  .next,
  .previous {
    cursor: pointer;
    background-color: inherit;
    border: none;
    svg {
      width: 20px;
      height: 20px;
    }
  }
  .next {
    margin-left: 16px;
  }
  .previous {
    margin-right: 16px;
  }
  button.year {
    cursor: pointer;
    border: none;
    padding: 16px;
    margin-left: 0.5px;
    margin-right: 0.5px;
    background-color: ${COLORS.grayLight};
  }
  .first-year {
    border-radius: 4px 0px 0px 4px;
  }
  .last-year {
    border-radius: 0px 4px 4px 0px;
  }
  button.selected {
    color: ${COLORS.whiteBase};
    background-color: ${COLORS.ctaPrimary};
  }
`;

const currentYear = new Date().getFullYear();
const PeriodSlider: React.FC<PeriodSelectorProps> = ({
  years,
  isThirdParty,
  selectedYear,
  handleNext,
  handlePrevious,
  handleChange,
}) => {
  const disableNext = !years[4];
  const disablePrevious = !years[0];

  return (
    <StyledDiv>
      <button
        onClick={handlePrevious}
        disabled={disablePrevious}
        className="previous"
      >
        <FontAwesomeIcon icon={faChevronLeft} />
      </button>
      <YearButton
        value={years[1]}
        onClick={handleChange}
        radius="left"
        selected={years[1].value === selectedYear?.value}
        disabled={isThirdParty ? years[1].value >= currentYear : false}
      />
      <YearButton
        value={years[2]}
        onClick={handleChange}
        selected={years[2].value === selectedYear?.value}
        disabled={isThirdParty ? years[2].value >= currentYear : false}
      />
      <YearButton
        value={years[3]}
        onClick={handleChange}
        radius="right"
        selected={years[3].value === selectedYear?.value}
        disabled={isThirdParty ? years[3].value >= currentYear : false}
      />
      <button onClick={handleNext} disabled={disableNext} className="next">
        <FontAwesomeIcon icon={faChevronRight} />
      </button>
    </StyledDiv>
  );
};

export default PeriodSlider;
